import { Injectable } from "@angular/core";
import { IAuditTrailDto } from "core/dto";
import { ApiService } from "../api.service";
import joinUrls from "../utils.ts/join-urls";

@Injectable({ providedIn: 'root' })
export class ReportRemoteControllerService {

    private readonly _endpoint = 'report'
    private readonly _getProcessAuditTrailEndpoint = 'audittrail/process'
    constructor(
        private readonly _apiService: ApiService
    ) {

    }


    getProcessAuditTrail(id: string, language: string) {

        const url = joinUrls(this._endpoint, this._getProcessAuditTrailEndpoint)
        return this._apiService.get<IAuditTrailDto>(url, { id, language })
    }
}